/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

import { t } from '../../locales/i18n';
import { userSignoutAC } from '../../action-creators';
import { setItem } from '../../db';

/** The provider is read once at app init, so switching starts the app afresh. */
async function switchProvider(providerId: string) {
  await setItem('providerId', providerId);
  window.location.reload();
}

export function RightMenu(props: any) {
  if (!props.myProfile) {
    return null;
  }
  const user = props.myProfile.authUser;
  if (!user) {
    return null;
  }

  const dispatch = props.dispatch;
  return (
    <Dropdown className={props.className} icon="ellipsis vertical">
      <Dropdown.Menu direction="left">
        <Dropdown.Item text={user.email} disabled />
        {props.providers && (
          <>
            <Dropdown.Divider />
            <Dropdown.Header content={t('Provider')} />
            {props.providers.map((p: any) => (
              <Dropdown.Item
                key={p.id}
                text={p.name}
                active={p.id === props.myProvider?.id}
                onClick={() => switchProvider(p.id)}
              />
            ))}
            <Dropdown.Divider />
          </>
        )}
        <Dropdown.Item onClick={() => dispatch(userSignoutAC())} text={t('Sign out')} />
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default connect((state: any) => ({
  myProfile: state.myProfile,
  myProvider: state.serviceProviders.myProvider,
  providers: state.serviceProviders.all
}))(RightMenu);
